module.exports = __webpack_public_path__ + "static/media/19pic.dc42d2ad.jpg";